<template>
    <div :class="['step-' + currentStep]">
        <input v-if="oldData.valn_order_id" type="hidden" name="valn_order_id" v-model="oldData.valn_order_id">
        <input v-if="oldData.valn_calc_id" type="hidden" name="valn_calc_id" v-model="oldData.valn_calc_id">
<!--        <div class="row">
            <div class="col-12">
                <h1>{{ this.title }}</h1>
            </div>
        </div>-->
        <div class="pt-1 flex-nowrap flex-column d-flex">
            <div class="card border-0 mb-3 order-lg-1">
                <div class="card-body pb-0">
                    <valuo-form-step-address :assets-url="assetsUrl"></valuo-form-step-address>
                </div>
            </div>
            <div class="card border-0 mb-3 bg-city order-lg-0">
                <div class="card-body pb-0 pb-lg-4">
                    <valuo-form-step-type :assets-url="assetsUrl"></valuo-form-step-type>
                </div>
            </div>
            <div class="card border-0 mb-3 order-lg-2">
                <div class="card-body pb-0 pb-lg-4">
                    <valuo-form-step-calculation :assets-url="assetsUrl"></valuo-form-step-calculation>
                </div>
            </div>
            <div class="card border-0 mb-3 order-lg-3">
                <div class="card-body pb-0 pb-lg-4">
                    <valuo-form-step-condition :assets-url="assetsUrl"></valuo-form-step-condition>
                    <valuo-form-step-floor :assets-url="assetsUrl"></valuo-form-step-floor>
                    <valuo-form-step-more :assets-url="assetsUrl"></valuo-form-step-more>
                </div>
            </div>
            <div class="card border-0 mb-3 order-lg-4">
                <div class="card-body pb-0 pb-lg-4">
                    <valuo-form-step-parameters :assets-url="assetsUrl" :display-custom-area="displayCustomArea"></valuo-form-step-parameters>
                </div>
            </div>
            <div class="card border-0 mb-3 order-lg-5">
                <div class="card-body">
                    <valuo-form-step-date></valuo-form-step-date>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Valuo-Form",

        props: ['backlink', 'assetsUrl', 'title', 'old', 'googleKey', 'googleCors', 'dateLimits', 'edit', 'displayCustomArea'],

        data: function() {
            return {
                currentStep: 1,
                maxVisitedStep: 1,
                steps: 8,
                titles: [
                    'Prodej/Pronájem',
                    'Typ nemovitosti',
                    'Parametry',
                    'Podlaží',
                    'Stav',
                    'Další informace',
                    'Adresa',
                    'Proč si odhad počítáte?'
                ],
                smallTitles: [
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'Čím přesnější adresu zadáte, tím přesnější bude odhad',
                    'Vaše odpověď nemá vliv na výsledek',
                ],
                type: 'flat',
                oldData: {},
                minDates: {}
            }
        },

        created: function() {
            try {
                this.oldData = JSON.parse(this.old);
            } catch (e) {
                this.oldData = {};
            }

            try {
                this.minDates = JSON.parse(this.dateLimits);
            } catch (e) {
                this.minDates = {};
            }
        },

        methods: {
            setType: function (type) {
                this.type = type;
            },

            getType: function () {
                return this.type;
            },
        },
    }
</script>

<style scoped>
    .wizard-position span {
        cursor: pointer;
    }

    .wizard-position span.disabled {
        cursor: not-allowed;
    }

    .small-header {
        color: #9d9d9d;
    }
</style>
